import React, { useState } from 'react'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { Delete, Edit } from '@mui/icons-material'
import toast from 'react-hot-toast'
import { useMutation } from '@apollo/client'
import { formatMoney, formatWhatsappNumber } from '../../utils/formatter'
import SaveCustomer from './SaveCustomer'
import DeleteDialog from '../shared/DeleteDialog'
import { DELETE_CUSTOMER } from '../../graphql/customers'

function WhatsappBtn({ phone }) {
  const formattedNumber = formatWhatsappNumber(phone)
  return (
    <a href={`https://wa.me/${formattedNumber}`} rel="noreferrer" target="_blank">
      <WhatsAppIcon sx={{ color: 'green', fontSize: 30, my: 0.8 }} />
    </a>
  )
}

function Customer({ customer, deleteCustomer }) {
  const [rowCustomer, setRowCustomer] = useState(customer)
  const {
    id, name, phone, email, orderStats,
  } = rowCustomer
  const [editOpen, toggleEdit] = useState(false)
  const [deleteOpen, toggleDelete] = useState(false)

  const deleteMsg = `Are you sure you want to delete customer ${name} - ${phone}?`

  const [deleteCustomerReq] = useMutation(DELETE_CUSTOMER, {
    onError: () => { toast.error(`Error deleting customer ${name}.`) },
    onCompleted: () => { toast.success(`Customer ${name} deleted successfully`); deleteCustomer(id) },
  })

  const handleDelete = () => {
    deleteCustomerReq({
      variables: {
        id,
      },
    })
    toggleDelete(false)
  }

  return (
    <tr>
      {
      editOpen ? (
        <SaveCustomer
          customer={rowCustomer}
          close={() => { toggleEdit(false) }}
          update={(c) => { setRowCustomer(c) }}
        />
      ) : null
     }
      <DeleteDialog visible={deleteOpen} close={() => { toggleDelete(false) }} title="Delete Customer" msg={deleteMsg} onDelete={handleDelete} />
      <td style={{ minWidth: '150px' }}>
        <p>{name}</p>
      </td>
      <td style={{ minWidth: '150px' }}>
        <p>{phone}</p>
      </td>
      <td style={{ minWidth: '150px' }}>
        <p>{email || '--'}</p>
      </td>
      <td style={{ minWidth: '150px' }}>
        <p>{orderStats.numOfOrders}</p>
      </td>
      <td style={{ minWidth: '150px' }}>
        <p>{formatMoney(orderStats.averageAmount)}</p>
      </td>
      <td style={{ minWidth: '200px' }}>
        <WhatsappBtn phone={phone} />
        <Edit sx={{ my: 0.8, mx: 4, cursor: 'pointer' }} onClick={() => { toggleEdit(true) }} />
        <Delete sx={{ my: 0.8, color: 'red', cursor: 'pointer' }} onClick={() => { toggleDelete(true) }} />
      </td>
    </tr>
  )
}

export default function CustomersView({ customers, deleteCustomer }) {
  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Phone No</th>
            <th>Email</th>
            <th>Total Orders</th>
            <th>Total Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((c) => <Customer key={c.id} customer={c} deleteCustomer={deleteCustomer} />)}
        </tbody>
      </table>
    </div>

  )
}
